


















































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import {MasterlinkTenantServiceProxy} from "@/service-proxies/app-v2/system.service-proxies";
import {
  ExtranetParamSetting,
  ExtranetParamSettingServiceProxy
} from "@/service-proxies/app-v2/iot-extranet.service-proxies";
const systemService = new MasterlinkTenantServiceProxy()
const paramSettingProxy = new ExtranetParamSettingServiceProxy()

@Component({
  components: {

  },
})
export default class PcList extends Vue {

  tenants=[];

  labelCol={ span: 4 };
  wrapperCol= { span: 14 };
  form= {
    tenantId: undefined,
    max:1,
    deleteEnable: false,
    editEnable: false
  }

  loading=false;

  mounted(){

    systemService.getTenants(undefined, 1, -1, undefined, undefined)
    .then(res=>{
      this.tenants = res.data.records.map((item) => ({ label: item.tenantName, value: item.tenantId }))
    })


  }

  tenantChange($event){
    this.loading=true;
    paramSettingProxy.getExtranetParamSetting($event)
      .then(res=>{
        this.form.deleteEnable = res.deleteEnable;
        this.form.editEnable = res.editEnable;
        this.form.max = res.max;
      })
      .finally(()=>{
        this.loading=false;
      });
  }

  saveData(){
    this.loading=true;
    const input = new ExtranetParamSetting()
    input.init(this.form);
    paramSettingProxy.saveExtranetParamSetting(input)
      .then(res=>{
        this.$message.success("保存配置成功");
      })
      .finally(()=>{
        this.loading=false;
      });
  }

}
